import axios from 'axios';

export const actions = {

  screenWidthChange ({ commit }) {
    commit('screenWidthChange');
  },
  changeIndex ({ commit }, data) {
    commit('changeIndex', data);
  },
  login ({ commit }, data) {
    commit('login', data);
  },
  updateAlbum ({ commit }, data) {
    commit('updateAlbum', data);
  },
  updateBlog ({ commit }, data) {
    commit('updateBlog', data);
  },

  // 发送信息 POST
  // data: {
  //   address,
  //   postData,
  // }
  post ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post(data.address, data.postData)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error, res) {
          if (error.response.status === 401) {
            reject('Not login');
          } else {
            reject(error);
          }
        });
    })
  },

  // 判断是否已匿名登录
  isLogin ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.isLogin) {
        axios.post('/api/isLogin')
          .then(function (response) {
            if (response.data.isLogin) {
              commit('login', response.data.userData);
              resolve();
            } else {
              axios.post('/api/anonymous')
                .then(function (response) {
                  commit('login', response.data.userData);
                  resolve();
                })
                .catch(function (error) {
                  reject(error.message);
                });
            }
          })
          .catch(function (error) {
            reject(error.message);
          });
      } else {
        resolve();
      }
    })
  },

  // 判断是否管理员已登录
  isAdminLogin ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let admin = false;
      if (!state.isLogin) {
        axios.post('/api/isLogin')
          .then(function (response) {
            if (response.data.isLogin) {
              commit('login', response.data.userData);
              isAdmin(response.data.userData.admin);
            } else {
              reject('Not login');
              console.log('bobosha');
              return;
            }
          })
          .catch(function (error) {
            reject(error.message);
            return ;
          });
      } else {
        isAdmin(state.userData.admin);
      }

      function isAdmin(admin) {
        if (admin) {
          resolve();
        } else {
          reject('No auth');
        }
      }

    })
  },

}



// WEBPACK FOOTER //
// ./src/store/actions.js